<template>
	<div id="app">
		<headers />
		<section class="app-main">
			<transition name="fade-transform" mode="out-in">
				<router-view :key="key" />
			</transition>
		</section>
		<footers /> 
	</div>
</template>
<script>
import Headers from '@/components/headers'
import Footers from '@/components/footers'
export default {
	components: {
		Headers,
		Footers,
	},
	data() {
		return {
			showBackToTop: false,
			threshold: 200,
		}
	},
	computed: {
		key() {
			return this.$route.path
		},
	},
	mounted() {
		// window.addEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		// window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		handleScroll() {
			this.showBackToTop = window.scrollY > this.threshold
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
	},
}
</script>
<style scoped>

</style>
